"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePayback = void 0;
function computePayback(inputs, buildPrice, monthlyFee = 0) {
    const orders = inputs?.ordersPerWeek ?? 0;
    const minutes = inputs?.minutesPerOrder ?? 0;
    const rate = inputs?.hourlyRate ?? 0;
    if (orders <= 0 || minutes <= 0 || rate <= 0)
        return null;
    const hoursPerWeek = (orders * minutes) / 60;
    const yearlyCost = hoursPerWeek * rate * 52;
    const monthlySaving = yearlyCost / 12 - (monthlyFee || 0);
    const paybackMonths = monthlySaving > 0 && buildPrice > 0 ? Math.max(1, Math.ceil(buildPrice / monthlySaving)) : null;
    return {
        hoursPerWeek: Math.round(hoursPerWeek * 10) / 10,
        yearlyCost: Math.round(yearlyCost),
        monthlySaving: Math.round(monthlySaving),
        paybackMonths,
    };
}
exports.computePayback = computePayback;
